import { createClient } from '@supabase/supabase-js'

const supabaseUrl = process.env.SUPABASE_URL
const supabasePublishableKey = process.env.SUPABASE_PUBLISHABLE_KEY

export const supabaseConfigured = Boolean(supabaseUrl && supabasePublishableKey)

// Los valores de respaldo solo permiten mostrar un error de configuración claro.
// Nunca se utilizan credenciales privilegiadas ni service_role en el navegador.
export const supabase = createClient(
  supabaseUrl || 'https://configuracion-pendiente.supabase.co',
  supabasePublishableKey || 'publishable-key-pending',
  { auth: { persistSession: true, autoRefreshToken: true, detectSessionInUrl: true } },
)
